<template>
  <v-page page="bcmItems">
    <v-container fluid ma-5>
      <v-row no-gutters justify="center">
        <v-col cols="4" xs="12" sm="12" md="10" lg="6">
          <!-- BREADCRUMB -->
          <v-row dense>
            <v-col>
              <v-card flat>
                <v-breadcrumbs :items="breadcrumb">
                  <template v-slot:divider>
                    <v-icon>mdi-chevron-right</v-icon>
                  </template>
                </v-breadcrumbs>
              </v-card>
            </v-col>
          </v-row>

          <!-- TITLE -->
          <v-row dense>
            <v-col>
              <v-card flat>
                <v-card-title class="text-h4">Item Explorer</v-card-title>
                <v-divider />
              </v-card>
            </v-col>
          </v-row>

          <!-- ITEM TABLE -->
          <v-row>
            <v-col>
              <v-card flat>
                <v-data-table
                  :headers="itemTableHeaders"
                  :items="taskItems"
                  :search="itemQuery"
                  dense
                  class="table-background"
                >
                  <template v-slot:top>
                    <v-toolbar flat color="#eee">
                      <v-text-field
                        v-model="itemQuery"
                        append-icon="mdi-magnify"
                        label="Search for a item..."
                        placeholder="hypothesis_score, PNS-gdex"
                        single-line
                        hide-details
                        clearable
                      ></v-text-field>
                      <v-spacer></v-spacer>
                      <task-item-dialog
                        :taskMap="getTaskMap(tasks)"
                        @taskItemSaved="initialize"
                      ></task-item-dialog>
                    </v-toolbar>
                  </template>
                  <template v-slot:item="props">
                    <tr>
                      <td>{{ parseTaskName(props.item.task_id) }}</td>
                      <td>{{ props.item.code }}</td>
                      <td>{{ props.item.name }}</td>
                      <td>{{ formatDate(props.item.created_at) }}</td>
                      <td>{{ formatDate(props.item.updated_at) }}</td>
                      <td>
                        <v-icon
                          small
                          class="ml-3"
                          @click="$goItemProfile(props.item.id)"
                        >
                          mdi-pencil
                        </v-icon>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-page>
</template>

<script>
import { Bus } from '@/bus'
import VPage from '@/layouts/Default'
import TaskItemDialog from '../components/items/dialog/CreateItem.vue'

export default {
  name: 'bcmItems',
  components: {
    VPage,
    TaskItemDialog
  },
  data () {
    return {
      tasks: [],
      taskItems: [],
      itemQuery: '',
      itemTableHeaders: [
        { text: 'Task', value: 'task_id', sortable: true },
        { text: 'Code', value: 'code', sortable: true },
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Date Created', value: 'created_at', sortable: true },
        { text: 'Last Updated', value: 'updated_at', sortable: true },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      breadcrumb: [
        {
          text: 'Explore',
          disabled: false,
          exact: true,
          to: '/bcm'
        },
        {
          text: 'Items',
          disabled: false
        }
      ]
    }
  },
  async created () {
    await this.initialize()
  },
  methods: {
    async initialize () {
      await this.getTasks()
      await this.getTaskItems()
    },
    async getTasks () {
      try {
        this.tasks = await this.$store.dispatch(
          'bcm/fetchBlueprintTasks',
          this.attribute ? { type: this.attribute, values: this.query } : null
        )
      } catch (err) {
        Bus.$emit('alert', {
          color: 'error',
          message: 'Failed to retrieve Blueprint Content Manager Tasks'
        })
      }
    },
    async getTaskItems () {
      try {
        this.taskItems = await this.$store.dispatch(
          'bcm/fetchTaskItems',
          this.attribute ? { type: this.attribute, values: this.query } : null
        )
      } catch (err) {
        Bus.$emit('alert', {
          color: 'error',
          message: 'Failed to retrieve Blueprint Content Manager Task Items'
        })
      }
    },
    parseTaskName (taskId) {
      const matchedTask = this.tasks.find(
        (task) => task.id === parseInt(taskId)
      )
      if (matchedTask) {
        return matchedTask.name
      }
    },
    getTaskMap (tasks) {
      return [
        ...new Set(
          tasks.map((task) => ({ name: task.name, task_id: task.id }))
        )
      ]
    },
    formatDate (dateString) {
      var options = { year: 'numeric', month: 'long', day: 'numeric' }
      const parsedDate = new Date(dateString)
      return parsedDate.toLocaleString('en-US', options)
    }
  }
}
</script>

<style scoped>
.table-background {
  background-color: #eee;
}
</style>
